var _path, _path2, _rect, _path3, _rect2, _g, _g2, _path4, _g3, _g4, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogin = function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 810,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#login_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#081F91",
    d: "M0 0h1000v810H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#login_svg__b)",
    d: "M77 73h846v664H77z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 646,
    height: 243,
    x: 527,
    y: 633,
    fill: "#2A4BF4",
    opacity: 0.5,
    rx: 121.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A4BF4",
    d: "M534.575-59.867c2.444 0 4.428 1.98 4.397 4.424a350 350 0 0 1-26.919 130.23c-17.79 42.69-43.865 81.479-76.737 114.153s-71.897 58.593-114.846 76.276A355.9 355.9 0 0 1 185 292c-46.488 0-92.52-9.101-135.47-26.784-42.949-17.683-81.974-43.602-114.846-76.276s-58.947-71.463-76.737-114.154a350 350 0 0 1-26.919-130.229c-.031-2.443 1.953-4.425 4.397-4.425H-1.011c2.444 0 4.42 1.982 4.48 4.425A179.6 179.6 0 0 0 17.235 9.204 180.4 180.4 0 0 0 56.6 67.76a181.7 181.7 0 0 0 58.911 39.126A182.6 182.6 0 0 0 185 120.625c23.846 0 47.459-4.669 69.49-13.739a181.7 181.7 0 0 0 58.911-39.126 180.4 180.4 0 0 0 39.363-58.556 179.6 179.6 0 0 0 13.768-64.647c.06-2.443 2.036-4.425 4.479-4.425z",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#login_svg__c)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 391,
    height: 306,
    x: 269,
    y: 229,
    fill: "#F6F6F9",
    rx: 6.505
  })), /*#__PURE__*/React.createElement("rect", {
    width: 323.698,
    height: 13.049,
    x: 298.031,
    y: 342.092,
    fill: "#6F79A8",
    fillOpacity: 0.15,
    rx: 6.525,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 323.698,
    height: 13.049,
    x: 298.031,
    y: 372.54,
    fill: "#6F79A8",
    fillOpacity: 0.15,
    rx: 6.525,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 323.698,
    height: 13.049,
    x: 298.031,
    y: 402.988,
    fill: "#6F79A8",
    fillOpacity: 0.15,
    rx: 6.525,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 323.698,
    height: 13.049,
    x: 298.031,
    y: 433.436,
    fill: "#6F79A8",
    fillOpacity: 0.15,
    rx: 6.525,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 166.929,
    height: 24.648,
    x: 298.031,
    y: 262.348,
    fill: "#2A4BF4",
    rx: 12.324,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.58,
    height: 24.648,
    x: 479.476,
    y: 262.348,
    fill: "#2A4BF4",
    rx: 12.324,
    style: {
      mixBlendMode: "multiply"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#login_svg__d)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#login_svg__e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 229,
    height: 216.81,
    x: 527,
    y: 427,
    fill: "#fff",
    rx: 11.702
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2B4FF4",
    d: "M641.907 504.091c-9.69 0-17.85 8.045-17.85 17.598s8.16 17.598 17.85 17.598 17.85-8.045 17.85-17.598-8.16-17.598-17.85-17.598m10.2 18.855h-8.925v8.799h-2.55v-8.799h-8.925v-2.514h8.925v-8.799h2.55v8.799h8.925z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#login_svg__f)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 770,
    cy: 386,
    r: 63,
    fill: "#2A4BF4"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m761.774 403.302-21.804-21.804a1 1 0 0 0-1.414 0l-4.439 4.44a.996.996 0 0 0 0 1.414l22.513 22.513 4.439 4.439a1 1 0 0 0 1.415 0l44.709-44.709a1 1 0 0 0 .024-1.39l-4.439-4.756a1 1 0 0 0-1.441-.022z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#login_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M172 425.42c0-7.412 6.008-13.42 13.42-13.42h190.151c7.412 0 13.42 6.008 13.42 13.42v35.654c0 7.411-6.008 13.419-13.42 13.419H185.42c-7.412 0-13.42-6.008-13.42-13.419z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#login_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2A4BF4",
    fillRule: "evenodd",
    d: "M375.571 418.71H185.42a6.71 6.71 0 0 0-6.71 6.71v35.654a6.71 6.71 0 0 0 6.71 6.71h190.151a6.71 6.71 0 0 0 6.71-6.71V425.42a6.71 6.71 0 0 0-6.71-6.71M185.42 412c-7.412 0-13.42 6.008-13.42 13.42v35.654c0 7.411 6.008 13.419 13.42 13.419h190.151c7.412 0 13.42-6.008 13.42-13.419V425.42c0-7.412-6.008-13.42-13.42-13.42z",
    clipRule: "evenodd"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 12,
    x: 607,
    y: 560,
    fill: "#9DB6FB",
    fillOpacity: 0.3,
    rx: 6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "login_svg__c",
    width: 427,
    height: 342,
    x: 251,
    y: 227,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect2_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1478_91559",
    result: "effect2_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1478_91559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "login_svg__d",
    width: 278.025,
    height: 265.835,
    x: 502.487,
    y: 424.276,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 21.789
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.256
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1.362,
    result: "effect2_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1478_91559",
    result: "effect2_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1478_91559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "login_svg__e",
    width: 236.021,
    height: 223.831,
    x: 523.489,
    y: 423.489,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.755
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1478_91559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "login_svg__f",
    width: 162,
    height: 162,
    x: 689,
    y: 321,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect2_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1478_91559",
    result: "effect2_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1478_91559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "login_svg__g",
    width: 236.991,
    height: 82.493,
    x: 162,
    y: 410,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect2_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1478_91559",
    result: "effect2_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1478_91559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "login_svg__h",
    width: 257.25,
    height: 102.752,
    x: 151.871,
    y: 409.763,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.893
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.065
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.380392 0 0 0 0 0.054902 0 0 0 0 0.635294 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1478_91559",
    result: "effect2_dropShadow_1478_91559"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_1478_91559",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "login_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v810H0z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "login_svg__b",
    width: 0.056,
    height: 0.076,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#login_svg__i",
    transform: "scale(.00069 .00088)"
  })), /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABXCAYAAAB81qkrAAAAAXNSR0IArs4c6QAAAN1JREFUeAHt2rEKgCAUBVDri9rq/6fa+qNaEhzioThIdFwUnw/x4HhTMggQIECAAAECBAgQIECAAIFIYIqKb7VjP6+8v25Lc3/urZm/ctdc8xhnYgGIsY8qAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAAQIECBAgQIAAgVqB5lTXV5JatQD5XM+7BJqyYscMsQNPKwECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIFCQCrswZAKK37FiKVU2Ah1dxIgQIAAAQIECBAgQIAAgZ8J3D5yJBChx57qAAAAAElFTkSuQmCC",
    id: "login_svg__i",
    width: 81,
    height: 87
  }))));
};
export { SvgLogin as ReactComponent };
export default new URL("/codebuild/output/src2083329490/src/src/assets/svgs/login.svg", import.meta.url).toString();